module.exports = __webpack_public_path__ + "img/carlsberg-logo.1a209d11.svg";